/*
 * @Author: shiguang
 * @Date: 2023-07-07 18:02:47
 * @LastEditors: shiguang
 * @LastEditTime: 2023-07-07 18:36:01
 * @Description: ROUTER_BASENAME
 */
export const ROUTER_BASENAME = 'oem';
